import createClient from "openapi-react-query";

import { QueryClient } from "@tanstack/react-query";

import { createOpenApiClient } from "@/providers/smarta-documents/documents-api-client";
import { getConfig } from "@/v1/config";
import { createAuthMiddleware } from "../../auth/openapiAuthMiddleware";

export const baseUrl = `${getConfig("VITE_APP_API_URL")}/api/kontax/documents`;

export const client = createOpenApiClient({
  baseUrl,
});
client.use(createAuthMiddleware());

export const queryClient = new QueryClient();

export const api = createClient(client);
